import Axios from "axios";
import React, { useEffect } from "react";
import { useState } from "react";
import { useParams, Link } from "react-router-dom";
import "./game.scss";
import { message, Skeleton } from 'antd';
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";


const Game = () => {
  let { id } = useParams();
  const [game, setGame] = useState(null);

  useEffect(() => {
    if (!game) {
      Axios.get(`https://backendexample.sanbersy.com/api/data-game/${id}`)
        .then((response) => {
          setGame(response.data);
        })
        
    }
  });
  return game ? (
    <div className="content">
      <div className="content__background">
        <div className="content__background__shadow" />
        <div
          className="content__background__image"
          style={{ backgroundImage: `url(${game.image_url})` }}
        />
      </div>
      <div className="content__area">
        <div className="content__area__container">
          <div className="content__title">{game.name}</div>
          <div className="content__genre">{game.genre}</div>
          <div className="content__type">
            Mode :
            {game.singlePlayer == 1 && game.multiPlayer == 1
              ? " Single Player, MultiPlayer "
              : game.singlePlayer == 1
                ? " Single Player"
                : game.multiPlayer == 1
                  ? " Multi Player"
                  : ""}
          </div>
          <div className="content__platform">Platform : {game.platform}</div>
          <div className="content__release">Release : {game.release}</div>
          <div
            style={{
              color: "white",
              fontSize: "1.4rem",
              position: "absolute",
              left: "3vw",
              bottom: "10vh",
              cursor: "pointer",
            }}
          >
            <Link to="/" style={{ color: "#fff" }}>
              <ArrowLeftOutlined /> Back To Home{" "}
            </Link>
          </div>
          <div
            style={{
              color: "white",
              fontSize: "1.4rem",
              position: "absolute",
              right: "3vw",
              bottom: "10vh",
              cursor: "pointer",
            }}
          >
            <Link to="/game_list" style={{ color: "#fff" }}>
              See All games <ArrowRightOutlined />
            </Link>
          </div>
        </div>

        )
      </div>
    </div>
  ) : ""
};

export default Game;
